import { motion } from "motion/react";
import { LANGS, setLang, useLang, type Lang } from "../i18n/lang";
import { useT } from "../i18n/strings";
import { haptic } from "../telegram/haptics";
import { pressSpring } from "../motion";
import s from "./ui.module.css";

/** Each language names itself; a reader looking for it should not need the other. */
const ENDONYM: Record<Lang, string> = { fa: "فا", en: "EN" };

/**
 * Two states, both visible. A dropdown would hide the option a first-time
 * reader is looking for, and there are only ever two.
 */
export function LanguageToggle() {
  const lang = useLang();
  const t = useT();

  return (
    <div className={s.langToggle} role="radiogroup" aria-label={t.actions.language}>
      {LANGS.map((option) => {
        const active = option === lang;
        return (
          <button
            key={option}
            type="button"
            role="radio"
            aria-checked={active}
            className={[s.langOption, active && s.langOptionActive].filter(Boolean).join(" ")}
            onClick={() => {
              if (active) return;
              haptic.select();
              setLang(option);
            }}
          >
            {active && (
              <motion.span layoutId="lang-pill" className={s.langPill} transition={pressSpring} />
            )}
            {ENDONYM[option]}
          </button>
        );
      })}
    </div>
  );
}
